import styled from 'styled-components';

type DropdownWrapperProps = {
  width?: number;
  disabled?: boolean;
};

export const DropdownWrapper = styled.span<DropdownWrapperProps>`
  width: ${(props) => (props.width ? `${props.width}px` : `100%`)};
  background-color: white;
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.2);
  position: relative;
  font-size: ${(props) => props.theme.typography.h5}px;
  pointer-events: ${(props) => (props.disabled ? `none` : `auto`)};
  ${(props) => props.disabled && `filter: grayscale(100%) opacity(30%);`};
  ${(props) => props.disabled && `pointer-events: none`};
  cursor: pointer;
`;
